import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { useStars } from "stars-rating-react-hooks";
import { AddSessionFeedback, GetSessionFeedback } from "../../redux/actions/SessionAction";

const ansArr = {
  star: 2,
  greater: [
    "Speaker joined on time",
    "Polite behavior",
    "Excellent spoken english",
  ],
  smaller: [
    "Speaker joined late",
    "My video got stuck"
  ],
};

const FeedbackModal = ({ show, setShow, id, number }) => {


  const dispatch = useDispatch()
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [rating, setRating] = useState();
  const [feedback, setFeedback] = useState([]);
  const [customAns, setCustomAns] = useState();
  const [component, setComponent] = useState(1);
  const [issueNotListed, setIssueNotListed] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleClose = () => setShow(false);

  console.log(id)

  console.log(id)

  useEffect(() => {
    if(id){
      const onSuccess = (res) => {
        // setLoader(false)
        // handleClose()
        // localStorage.removeItem("FEEDBACK_TIME");
        // openSnackbar(res.message)
        console.log(res)
        
        setRating(res.data.ratingData.rating);
      }
      const onError = (err) => {
        // setLoader(false)
        // openSnackbar(err)
        console.log(err)
      }
      dispatch(GetSessionFeedback({ sessionId: id }, onSuccess, onError))
    }
    
  
  }, [id])
 

  console.log(rating);
  const rat = rating;
  console.log(rat)
  const config = {
    totalStars: 5,
    initialSelectedValue: rating,
    renderFull: "★",
    renderEmpty: "☆",
  };
  useEffect(() => {
   if(rating){
     config["initialSelectedValue"]=rating;
   }
  }, [rating])
  const { stars, getStarProps } = useStars(config);

  const userFeedback = (checkbox) => {
    var _feedback = feedback
    if (checkbox.checked) {
      setFeedback([..._feedback, checkbox.value])
    } else {
      const result = _feedback.filter(val => val !== checkbox.value);
      setFeedback(result)
    }
  }


  const addFeedback = () => {
    setLoader(true)

    var qa = []
    var i = 0
    for (i; i < feedback.length; i++) {
      qa.push(
        {
          "question": "What did you like/not liked?",
          "answer": feedback[i]
        }
      )
    }

    if (customAns) {
      qa.push(
        {
          "question": "Typed Response",
          "answer": customAns
        }
      )
    }

    var data = {
      sessionId: id,
      "Rating": rating,
      "QA": qa
    }
    console.log(data)
    const onSuccess = (res) => {
      setLoader(false)
      handleClose()
      localStorage.removeItem("FEEDBACK_TIME");
      openSnackbar(res.message)
    }
    const onError = (err) => {
      setLoader(false)
      openSnackbar(err)
    }
    dispatch(AddSessionFeedback(data, onSuccess, onError))
  }


  return (
    <div>
      <Modal show={show} onHide={handleClose} className="session-feedback">
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>Session {number} Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div>
            {/* <div className="d-flex">
                <hr className="line active-line" />
                <hr
                  className="line deactivate-line ml-2"
                  onClick={() => setComponent(2)}
                />
              </div> */}

            <h4>How’d the session go?</h4>
            <p>
              Rate your experience with the <br /> session.
            </p>
            <div className="d-flex justify-content-between rating">
              {stars?.map((star, i) => (
                <span
                  key={i}
                  {...getStarProps(i, {
                    onClick: (event, ratedValue) => {
                      setRating(ratedValue);
                      setComponent(2);
                    },
                  })}
                >
                  {star}
                </span>
              ))}
            </div>
          </div>
          {component === 2 ? (
            <div className="mt-2">
              {/* <div className="d-flex">
                <hr
                  className="line deactivate-line"
                  onClick={() => setComponent(1)}
                />
                <hr className="line active-line ml-2" />
              </div> */}

              <h4>{rating >= 3 ? "What did you like 😃?" : "What did you not like 😔?"}</h4>
              <p>{issueNotListed || rating <= 3 ? "Could you share what we can do better?" : "Tell us more about the speaker."}</p>
              <div className="d-flex flex-wrap feedback">
                {!issueNotListed ? (
                  rating > ansArr.star ? (
                    ansArr.greater.map((data, i) => {
                      return (
                        <div key={i} className="checkbox">
                          <input type="checkbox" id={data} value={data} checked={feedback.includes(data)} onChange={(e) => userFeedback(e.target)} />
                          <label for={data}>{data}</label>
                        </div>
                      )
                      //<input type="checkbox" name={data} value={data} key={i}/>;
                    })
                  ) : (
                    ansArr.smaller.map((data, i) => {
                      return (
                        <div key={i} className="checkbox">
                          <input type="checkbox" id={data} value={data} checked={feedback.includes(data)} onChange={(e) => userFeedback(e.target)} />
                          <label for={data}>{data}</label>
                        </div>
                      )
                    })
                  )
                ) : (
                  <textarea placeholder="Enter some text..." onChange={(e) => setCustomAns(e.target.value)}></textarea>
                )}

              </div>
              {rating < ansArr.star ? !issueNotListed ? <p className="not-listed mt-3" onClick={() => setIssueNotListed(true)}>Issue not listed here?</p> : <p className="not-listed mt-3" onClick={() => setIssueNotListed(false)}>Select from options?</p> : ""}

            </div>
          ) : ""}
        </Modal.Body>
        <Modal.Footer className="border-0 ">
          <Button onClick={addFeedback} disabled={rating < 1 || loader}>
            {loader ? "Loading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FeedbackModal;
